import { render, staticRenderFns } from "./topbutton.vue?vue&type=template&id=5a0ce5fe&scoped=true"
import script from "./topbutton.vue?vue&type=script&lang=js"
export * from "./topbutton.vue?vue&type=script&lang=js"
import style0 from "./topbutton.vue?vue&type=style&index=0&id=5a0ce5fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0ce5fe",
  null
  
)

export default component.exports